import { render, staticRenderFns } from "./EditBillingEvent.vue?vue&type=template&id=56e00a04"
import script from "./EditBillingEvent.vue?vue&type=script&lang=js"
export * from "./EditBillingEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports